import { Component, Inject, Input, Optional, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { GlobalService } from '../../services/global.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AbbyyLineItemsDto, CostCenterLookupResponseDto, GLAccountLookupRequest, GLAccountLookupResponseDto, GlEntry, GlEntryResponseDto, GlEntryView, LineItem, LineItemResponseDto, TradingPartnerLookupResponseDto } from '../../models/lineItemsDtos';
import { AutoCompleteSelectEvent } from 'primeng/autocomplete';
import { custNWEGLEntryHeaders, custWBGLEntryHeaders, glEntryHeaders, lineItemsHeaders, retrievalGLEntryHeaders } from '../../common/staticGridColumnHeader';
import { DialogComponent, DialogData } from '../dialog/dialog.component';


@Component({
  selector: 'app-line-items-gl-entry',
  templateUrl: './line-items-gl-entry.component.html',
  styleUrl: './line-items-gl-entry.component.scss'
})
export class LineItemsGlEntryComponent {
  @Input() docId?: string;
  @Input() abbyyBatchId?: string;
  @Input() abbyyDocId?: string;
  @Input() isFromDocViewer?: boolean = false;
  @Input() isEditableGLEntryTable: boolean = false;
  @Input() isWIInCustOrNonPOApprovalQueues: boolean = false; 
  @Input() isCustGLEntryTableDisplay: boolean = false;
  @Input() isCustWorkFlowBaName: string = "";
  @Input() documentTypeId?: number;
  @Input() queueId?: string;
  @Input() isRetrieval: boolean = false;
  @Input() isVendorIntercompany: boolean = false;
  @Input() mappedCompanyCode: string = "";
  @Input() workflowId: number = 0;
  @Output() glEntriesCountChanged = new EventEmitter<number>();
  @Output() saveCompleted = new EventEmitter<void>();
  isDataAvailable: boolean = true;
  selectedType: 'lineItem' | 'glEntry' = 'lineItem';  // default
  columnsLineItemsTable: any[] = lineItemsHeaders;
  columnsGLEntryTable: any[] = glEntryHeaders;
  columnsCustGLEntryTable = this.globalVariable.getSelectedSystemId === '6000' 
  ? custWBGLEntryHeaders 
  : custNWEGLEntryHeaders;
  columnsRetrievalGLEntryTable: any[] = retrievalGLEntryHeaders;
  selectedTable: string = 'LineItemsTable';
  lineItems: LineItem[] = [];
  glEntries: GlEntry[] = [];
  lineItemsPageNo = 0;
  glEntriesPageNo = 0;
  lineItemsTotalCount = 0;
  glEntriesTotalCount = 0;
  documentId: string = '';
  GlEntryData: GlEntryView[] = [];
  selectedGlEntryData: GlEntryView[] = [];
  isTableLoading: boolean = true;
  sortField: string = "";
  sortOrder: number = 1; // 1 for ascending, -1 for descending
  editingGLEntryTableRows: { [index: number]: boolean } = {};
  totalRecords: number = 0;
  clonedRows: { [index: number]: GlEntryView } = {};
  isAnyRowBeingEdited: boolean = false;
  searchTextendorName: string = "";
  pageNumber: number = 0;
  rowsOptions = [
    { label: '10', value: 10 },
    { label: '25', value: 25 },
    { label: '50', value: 50 },
    { label: '75', value: 75 },
    { label: '100', value: 100 },
    { label: '200', value: 200 },
    { label: '300', value: 300 },
    { label: '500', value: 500 },
    { label: 'All', value: 0 }
  ];
  rows: number = 10;
  dragSelecting = false;
  selectedIndexes: number[] = [];
  pagesToHoldData: number = 0;
  // Filtering
  filters: { [key: string]: any } = {};
  relatedFields = ['costCenter', 'profitCenter', 'wbsElement'];
  filteredGlCodes: GLAccountLookupResponseDto[] = [];
  filteredCostCenters: CostCenterLookupResponseDto[] = [];
  filteredTradingPartners: TradingPartnerLookupResponseDto[] = [];
  rowData: any = {}; 
  isOverflowing: boolean = false;
  validationTouched: boolean[] = [];
  selectedCostCenters: any[] = [];
  selectedGLAccounts: any[] = [];
  selectedTradingPartner: any[] = [];
  activityTypeOptions: any[] = [];
  glAccountOptions: any[] = [];
  companyCodeMappings: any[] = [];
  frGlAccountCostCenterMappings: any[] = [];
  isCustNWEGLEntry: boolean = false;
  isInFRPenaltyCodingQueue: boolean = false;
  isInDEWorkflow: boolean = false;
  isInBENLWorkflow: boolean = false;
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRef: MatDialogRef<LineItemsGlEntryComponent>,
    private readonly commonService: CommonService,
    private readonly globalVariable: GlobalService,
    private readonly dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.documentId = this.docId || this.data?.docId || '';
    this.abbyyBatchId = this.abbyyBatchId || this.data?.abbyyBatchId;
    this.abbyyDocId = this.abbyyDocId || this.data?.abbyyDocId;
    this.isRetrieval = this.isRetrieval || this.data?.isRetrieval;

    this.selectedTable = this.isWIInCustOrNonPOApprovalQueues
      ? 'GLEntryTable'
      : 'LineItemsTable';

    this.configureCustomGLEntryTable();

    if (this.globalVariable.getSelectedSystemId === '6002' && this.queueId &&
      ['505', '507', '876', '878', '768', '770', '660', '662'].includes(this.queueId)//ICONonPOQueues
    ) {
      const tradingPartnerCol = this.columnsGLEntryTable.find(col => col.field === 'tradingPartner');

      if (tradingPartnerCol) {
        tradingPartnerCol.type = 'tradingPartnerAutoComplete';
      }
    }

    this.commonService.clearMessage();
    
    this.loadData();

    this.initializeEditableGLEntryTable();
  }

  private configureCustomGLEntryTable(): void {
    if (!this.isCustGLEntryTableDisplay || this.globalVariable.getSelectedSystemId !== '6002') {
      return;
    }

    this.isCustNWEGLEntry = true;

    if (this.queueId === '415') {
      const assignmentCol = this.columnsCustGLEntryTable.find(col => col.field === 'assignment');
      if (assignmentCol) {
        assignmentCol.required = true;
      }
    }

    if (this.queueId === '895') {
      this.isInFRPenaltyCodingQueue = true;
      
      const costCenterCol = this.columnsCustGLEntryTable.find(col => col.field === 'costCenter');
      if (costCenterCol) {
        costCenterCol.required = true;
      }

      const wbsElementCol = this.columnsCustGLEntryTable.find(col => col.field === 'wbsElement');
      if (wbsElementCol) {
        wbsElementCol.required = false;
      }
    }

    if (this.workflowId === 552 || this.workflowId === 539) {
      this.isInBENLWorkflow = true;

      this.columnsCustGLEntryTable = this.columnsCustGLEntryTable.filter(
        col => !['costCenter', 'wbsElement', 'assignment'].includes(col.field)
      );

      const profitCenterCol = this.columnsCustGLEntryTable.find(col => col.field === 'profitCenter');
      if (profitCenterCol) {
        profitCenterCol.required = true;
      }

      return;
    }

    if (this.workflowId === 526) {
      this.isInDEWorkflow = true;

      this.columnsCustGLEntryTable = this.columnsCustGLEntryTable.filter(
        col => !['assignment', 'copaLevel7', 'copaLevel8'].includes(col.field)
      );

      const wbsElementCol = this.columnsCustGLEntryTable.find(col => col.field === 'wbsElement');
      if (wbsElementCol) {
        wbsElementCol.required = false;
      }

      return;
    }

    this.columnsCustGLEntryTable = this.columnsCustGLEntryTable.filter(
      col => !['profitCenter', 'copaLevel7', 'copaLevel8'].includes(col.field)
    );
  }

  private initializeEditableGLEntryTable(): void {
    if (!this.isEditableGLEntryTable) {
      return;
    }

    if (this.isCustGLEntryTableDisplay && !this.isCustNWEGLEntry) {
      this.getActivityTypeValues();
    } else if (this.isCustGLEntryTableDisplay && this.isCustNWEGLEntry) {
      this.getCustNonPOFRGLAccountValues();
    }

    this.getCompanyCodeMappings();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isVendorIntercompany'] && !changes['isVendorIntercompany'].isFirstChange()) {
      this.updateTradingPartnerRequired();
    }
  }

  updateTradingPartnerRequired() {
    const tradingPartnerCol = this.columnsGLEntryTable.find(col => col.field === 'tradingPartner');
    if (tradingPartnerCol) {
      tradingPartnerCol.required = this.isVendorIntercompany;
    }
  }

  checkOverflow(element: HTMLElement) {
    this.isOverflowing = element.offsetWidth < element.scrollWidth;
  }

  isAllEmpty(rowData: any): boolean {
    return this.relatedFields.every(field => !rowData[field]);
  }

  get currentData() {
    return this.selectedTable === 'LineItemsTable' ? this.lineItems : this.GlEntryData;
  }

  get currentColumns() {
    if (this.selectedTable === 'LineItemsTable') {
      return this.columnsLineItemsTable;
    }
    if (this.isRetrieval) {
      return this.columnsRetrievalGLEntryTable;
    }

    if (this.isCustGLEntryTableDisplay) {
      return this.columnsCustGLEntryTable;
    }

    return this.columnsGLEntryTable;
  }

  selectTable(table: 'LineItemsTable' | 'GLEntryTable') {
    this.selectedTable = table;
  }

  get canEditGLEntryTable(): boolean {
    return this.selectedTable === 'GLEntryTable'&& this.isEditableGLEntryTable;
  }

  getButtonClass(table: string) {
    return this.selectedTable === table ? 'p-button-success' : 'p-button-secondary';
  }

  onRowsChange(event: Event) {
    this.selectedIndexes = [];
    this.syncSelectedWorkItems();
    const target = event.target as HTMLSelectElement;
    const selectedValue = Number(target.value);
    this.rows = selectedValue === 0 ? this.GlEntryData.length : selectedValue;
  }

  saveRow(index: number) {
    const row = this.GlEntryData[index]; 
    if (!this.validateRow(row, index)) {
       this.validationTouched[index] = true;
      this.isAnyRowBeingEdited = true;
      return;
    }
    delete this.clonedRows[index];
    delete this.editingGLEntryTableRows[index];
    this.validationTouched.splice(index, 1);
    this.saveAbbyyLineItems(row);
    this.isAnyRowBeingEdited = false;
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  saveAbbyyLineItems(glEntryData: GlEntryView): void {
    let GLEntryData: GlEntry;
    const { isNew, ...rest } = glEntryData;
    GLEntryData = {
      docItemNumber: rest.docItemNumber,
      glAccount: rest.glAccount,
      glAcName: rest.glAcName,
      debitCredit: rest.debitCredit,
      amount: rest.amount?.toString().replace(/,/g, '.'),
      taxCode: rest.taxCode,
      itemText: rest.itemText,
      assignment: rest.assignment ?? '',
      costCenter: rest.costCenter ?? '',
      costCenterName: rest.costCenterName ?? '',
      profitCenter: rest.profitCenter ?? '',
      wbsElement: rest.wbsElement ?? '',
      tradingPartner: rest.tradingPartner ?? '',
      activityType: rest.activityType ?? '',
      copaLevel7: rest.copaLevel7 ?? '',
      copaLevel8: rest.copaLevel8 ?? '',
      isInternalCall: true
    };
    let saveAbbyyLineItemsDetail: AbbyyLineItemsDto = {
      systemId: Number(this.globalVariable.getSelectedSystemId),
      userGpid: this.globalVariable.getUserGPID,
      documentId: Number(this.documentId),
      abbyy_BatchId: Number(this.abbyyBatchId),
      abbyy_DocId: Number(this.abbyyDocId),
      type: 'GL',
      isUIRequest: true,
      matchedLineItems: [],
      glLineItems: [GLEntryData],
    }
    this.commonService.saveAbbyyLineItems(saveAbbyyLineItemsDetail).subscribe({
      next: (response) => {
        if(response){
          this.loadGlEntriesPage();
          this.commonService.showMessage("Saved Successfully.", 'success');
        }
        this.saveCompleted.emit();
      },
      error: (error) => {
        this.loadGlEntriesPage();
        this.commonService.showMessage(error.error.message, 'error');
        this.errorModalPopUp("ERROR", error.error.message);
        this.saveCompleted.emit();
      }
    });
  }

  errorModalPopUp(title: string, message: string): void {
    const dialogData: DialogData = {
      title: title,
      message: message,
      showCancelButton: false,
      showButtons: false
    };
    this.dialog.open(DialogComponent, {
      width: '600px',
      data: dialogData,
    });
  }

  validateRow(row: GlEntryView, index: number): boolean {
    
    const original = this.clonedRows[index];
    const isGlAccountValid = (!!row.glAccount && this.selectedGLAccounts[index]) || row.glAccount === original?.glAccount;
    const isCostCenterValid = (!!row.costCenter && this.selectedCostCenters[index]) || row.costCenter === original?.costCenter;

    if (!this.isCustGLEntryTableDisplay) {
      return this.validateStandardGLEntry(row, index, isGlAccountValid, isCostCenterValid);
    }

    if (this.isCustNWEGLEntry) {
      return this.validateCustomNWEGLEntry(row, index, isGlAccountValid, isCostCenterValid);
    }

    return (
      !!row.activityType &&
      !!row.glAccount &&
      !!row.amount &&
      !!row.profitCenter &&
      !!row.taxCode &&
      !!row.debitCredit
    );
  }

  private validateStandardGLEntry(row: GlEntryView, index: number, isGlAccountValid: boolean, isCostCenterValid: boolean): boolean {

    const isTradingPartnerRequired = this.columnsGLEntryTable.find(col => col.field === 'tradingPartner')?.required;
    const isTradingPartnerValid = !isTradingPartnerRequired || (!!row.tradingPartner && this.isAutoCompleteValueValid(row, index, 'tradingPartner'));
    const isAccountAssignmentValid = (row.costCenter && isCostCenterValid) || !!row.profitCenter || !!row.wbsElement;

    return (
      isGlAccountValid &&
      !!row.amount &&
      isTradingPartnerValid &&
      isAccountAssignmentValid
    );
  }

  private validateCustomNWEGLEntry(row: GlEntryView, index: number, isGlAccountValid: boolean, isCostCenterValid: boolean): boolean {
    if (this.isInDEWorkflow) {
      return (
        !!row.amount &&
        !!row.taxCode &&
        !!row.debitCredit &&
        isGlAccountValid &&
        (
          (row.costCenter && isCostCenterValid) ||
          !!row.profitCenter ||
          !!row.wbsElement
        )
      );
    }

    if (this.isInBENLWorkflow) {

      const isCopaLevel7Valid = !!row.copaLevel7 && this.isAutoCompleteValueValid(row, index, 'copaLevel7');
      const isCopaLevel8Valid = !!row.copaLevel8 && this.isAutoCompleteValueValid(row, index, 'copaLevel8');

      return (
        !!row.amount &&
        !!row.taxCode &&
        !!row.debitCredit &&
        isGlAccountValid &&
        !!row.profitCenter &&
        isCopaLevel7Valid &&
        isCopaLevel8Valid
      );
    }

    return this.validateNWEStandardGLEntry(row, isCostCenterValid);
  }

  private validateNWEStandardGLEntry(row: GlEntryView, isCostCenterValid: boolean): boolean {

    const isAssignmentRequired = this.queueId === '415' && this.columnsCustGLEntryTable.some(col => col.field === 'assignment' && col.required);
    const isCostCenterRequired = this.queueId === '895' && this.columnsCustGLEntryTable.some(col => col.field === 'costCenter' && col.required);
    const isWbsElementRequired = !this.isInFRPenaltyCodingQueue;

    return (
      !!row.amount &&
      !!row.taxCode &&
      !!row.debitCredit &&
      !!row.glAccount &&
      (!isCostCenterRequired || (!!row.costCenter && isCostCenterValid)) &&
      (!isAssignmentRequired || !!row.assignment) &&
      (!isWbsElementRequired || !!row.wbsElement)
    );
  }

  isAutoCompleteValueValid(row: GlEntryView, index: number, field: string): boolean {
    const rowValue = (row as any)[field];
    const originalValue = (this.clonedRows[index] as any)?.[field];

    // Existing unchanged value is valid
    if (rowValue === originalValue) {
      return true;
    }

    // Only Trading Partner depends on the column type
    if (field === 'tradingPartner') {
      const column = this.columnsGLEntryTable.find(
        col => col.field === 'tradingPartner'
      );

      // If Trading Partner is not an autocomplete field,
      // don't require selection from the autocomplete list.
      if (!column || column.type !== 'tradingPartnerAutoComplete') {
        return true;
      }

      return !!this.selectedTradingPartner[index];
    }

    return true;
  }

  cancelSave(index?: any): void {

    const row = this.GlEntryData[index];

    if (row.isNew) {
      this.GlEntryData.splice(index, 1);
      // Update clone and editing status
      delete this.clonedRows[index];
      delete this.editingGLEntryTableRows[index];
      this.isAnyRowBeingEdited = false;
      return;
    }
    if (this.clonedRows[index]) {
      this.GlEntryData[index] = { ...this.clonedRows[index] };
      delete this.clonedRows[index];
    }

    delete this.editingGLEntryTableRows[index];
    this.isAnyRowBeingEdited = false;
  }

  editRow(index: number) {
    if (this.isAnyRowBeingEdited) return;
    const row = this.GlEntryData[index];
    if (this.isInFRPenaltyCodingQueue && !row.taxCode) {
      row.taxCode = 'V0';
    }
    this.clonedRows[index] = { ...row };
    this.editingGLEntryTableRows[index] = true;
    this.isAnyRowBeingEdited = true;

    setTimeout(() => {
      const inputEl = document.querySelector(`#input-${index}`) as HTMLElement;
      if (inputEl) {
        inputEl.focus();
      }
    });
  }

  deleteRow(index: number) {
    if (this.isAnyRowBeingEdited) return;
    this.isAnyRowBeingEdited = true;
    const row = this.GlEntryData[index];

    this.commonService.deleteGLLineItem(this.globalVariable.getUserGPID, this.globalVariable.getSelectedSystemId,
      this.documentId,
      row.docItemNumber).subscribe({
        next: (response) => {
          if (response) {
            this.isAnyRowBeingEdited = false;
            this.loadGlEntriesPage();
            this.commonService.showMessage("Deleted Successfully.", 'success');
          }
        },
        error: (error) => {
          this.commonService.showMessage(error.error.message, 'error');
        }
      });
  }

  addNewRow() {
    if (this.isAnyRowBeingEdited) return;
    const newRow: GlEntryView = {
      docItemNumber: "",
      glAccount: "",
      glAcName: "",
      debitCredit: "",
      amount: "",
      taxCode: this.isInFRPenaltyCodingQueue ? "V0" : "", // Default display 'V0' for PenalityCodingQueue
      itemText: "",
      assignment: "",
      costCenter: "",
      costCenterName: "",
      profitCenter: "",
      wbsElement: "",
      tradingPartner: "",
      isNew: true,
      activityType: "",
      isInternalCall: true
    };
    this.GlEntryData.unshift(newRow);
    this.editingGLEntryTableRows[0] = true;
    this.isAnyRowBeingEdited = true;
  }

  onPageChange(event: any) {
    const currentPage = Math.ceil(event.first / event.rows) + 1;
    const rowsPerPage = event.rows;
    const totalPages = Math.ceil(this.totalRecords / rowsPerPage);
    const isLastPage = currentPage === totalPages - 1;
    if (isLastPage) {
      this.pagesToHoldData = event.first;
      this.loadData();
    }
  }

  loadData(): void {
    this.isTableLoading = true;

    this.lineItemsPageNo = 0;
    this.glEntriesPageNo = 0;

    this.lineItems = [];
    this.glEntries = [];

    this.loadLineItemsPage();
    this.loadGlEntriesPage();
  }

  loadLineItemsPage(): void {
    const docId = this.documentId;

    this.commonService.getGetAbbyyLineItems(
      this.globalVariable.getUserGPID, this.globalVariable.getSelectedSystemId,
      docId,
      'MATCHED',
      this.lineItemsPageNo
    ).subscribe({
      next: (response) => {
        const lineItemResponse = response as LineItemResponseDto;

        this.lineItems = [...this.lineItems, ...lineItemResponse.results];
        this.lineItemsTotalCount = lineItemResponse.rowCount;
        this.isDataAvailable = this.lineItems.length > 0 || this.glEntries.length > 0;
        this.isTableLoading = false;
      },
      error: (err) => {
        this.commonService.showMessage('Error loading line items: ' + err.error.message, 'error');
        this.isTableLoading = false;
        this.isDataAvailable = false;
      }
    });
  }




  loadGlEntriesPage(): void {
    this.commonService.getGetAbbyyLineItems(
      this.globalVariable.getUserGPID, 
      this.globalVariable.getSelectedSystemId,
      this.documentId,
      'GL',
      this.glEntriesPageNo
    ).subscribe({
      next: (response) => {
        const glEntryResponse = response as GlEntryResponseDto;
        this.glEntries = [...this.glEntries, ...glEntryResponse.results];
        this.glEntriesTotalCount = glEntryResponse.rowCount;
        this.glEntriesCountChanged.emit(this.glEntriesTotalCount);
        this.isDataAvailable = this.lineItems.length > 0 || this.glEntries.length > 0;
        this.totalRecords = this.totalRecords === 0
          ? response.rowCount
          : this.totalRecords + response.rowCount;
        function isGlEntry(item: any): item is GlEntry {
          return 'glAccount' in item;
        }
        this.GlEntryData = response.results
          .filter(isGlEntry)
          .map(item => ({
            docItemNumber: item.docItemNumber ?? '',
            glAccount: item.glAccount ?? '',
            glAcName: item.glAcName ?? '',
            debitCredit: item.debitCredit ?? '',
            amount: item.amount ?? '',
            taxCode: item.taxCode ?? '',
            itemText: item.itemText ?? '',
            assignment: item.assignment ?? '',
            costCenter: item.costCenter ?? '',
            costCenterName: item.costCenterName ?? '',
            profitCenter: item.profitCenter ?? '',
            wbsElement: item.wbsElement ?? '',
            tradingPartner: item.tradingPartner ?? '',
            isNew: false,
            activityType: item.activityType ?? '',
            copaLevel7: item.copaLevel7 ?? '',
            copaLevel8: item.copaLevel8 ?? '',
            isInternalCall: item.isInternalCall ?? true,
          }));
        this.isTableLoading = false;
      },
      error: (err) => {
        this.commonService.showMessage('Error loading GL Entry :' + err.error.message, 'error');
        this.isTableLoading = false;
        this.isDataAvailable = false;
      }
    });
  }

  isSelected(index: number): boolean {
    return this.selectedIndexes.includes(index);
  }

  onRowClick(event: MouseEvent, index: number): void {
    this.toggleRowSelection(index, event.ctrlKey || event.metaKey, event.shiftKey);
  }

  toggleRowSelection(index: number, ctrlKey: boolean, shiftKey: boolean): void {
    if (!ctrlKey && !shiftKey) {
      this.selectedIndexes = [index];
    }
    else {
      const alreadySelected = this.selectedIndexes.includes(index);
      if (!alreadySelected) {
        this.selectedIndexes.push(index);
      }
      else {
        this.selectedIndexes = this.selectedIndexes.filter(i => i !== index);
      }
    }
    this.syncSelectedWorkItems();
  }

  onMouseDown(event: MouseEvent, index: number) {
    const ctrlKey = event.ctrlKey || event.metaKey;
    const shiftKey = event.shiftKey;
    if (event.button === 0 && !ctrlKey && !shiftKey) {
      this.dragSelecting = true;
      this.selectedIndexes = [index];
      this.syncSelectedWorkItems();
      event.preventDefault();
    }
  }

  onMouseOver(event: MouseEvent, index: number) {
    if (event.button === 0 && this.dragSelecting && !this.selectedIndexes.includes(index)) {
      this.selectedIndexes.push(index);
      this.syncSelectedWorkItems();
    }
  }

  onMouseUp(event: MouseEvent) {
    if (this.dragSelecting) {
      this.dragSelecting = false;
    }
  }

  onRowKeydown(event: KeyboardEvent, index: number): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleRowSelection(index, event.ctrlKey || event.metaKey, event.shiftKey);
    }
  }

  onRowFocus(_event: FocusEvent, _index: number): void {
  }

  syncSelectedWorkItems() {
    this.selectedGlEntryData = this.selectedIndexes
      .filter(i => i >= 0 && i < this.GlEntryData.length) // Ensure within bounds
      .map(i => this.GlEntryData[i]);
  }

  // Method to handle column reordering event
  onColumnReordered(event: any) {
    if (!this.columnsLineItemsTable || !Array.isArray(this.columnsLineItemsTable)) {
      return;
    }
    this.columnsLineItemsTable = this.columnsLineItemsTable.map((col, index) => ({
      ...col,
      Order: index + 1
    }));
  }

  searchGlCodes(event: any, field: string) {
    if (!event || typeof event.query !== 'string') {
      return;
    }

    const value = event.query;
    let lookupFieldName: string;
    if (/^\d/.test(value)) {
      lookupFieldName = "GLACCOUNT";
    } else if (/^[A-Za-z]/.test(value)) {
      lookupFieldName = "GLACCOUNTNAME";
    } else {
      lookupFieldName = "GLACCOUNT";
    }
    const payload: GLAccountLookupRequest = {
      userGpid: this.globalVariable.getUserGPID,
      systemId: Number(this.globalVariable.getSelectedSystemId),
      lookupFieldName: lookupFieldName,
      lookupFieldValue: value,
      companyCode: this.mappedCompanyCode?.trim() ||  this.companyCodeMappings[0].companyCode
    };

    this.commonService.getGLAutoComboValueLookup<GLAccountLookupResponseDto>(payload).subscribe({
      next: (response: GLAccountLookupResponseDto[]) => {
        this.filteredGlCodes = response;
      },
      error: (err) => {
        this.commonService.showMessage('Error loading GL Account values: ' + err.error.message, 'error');
      }
    });
  }

  searchAutoComplete(event: any, col: any): void {
    if (!event || typeof event.query !== 'string') {
        return;
    }
    const lookupConfig: Record < string, {
        lookupFieldName: string;
        requiresCompanyCode ?  : boolean;
    }
      >  = {
        tradingPartnerAutoComplete: {
            lookupFieldName: 'TRADINGPARTNER',
        },
    };

    const config = lookupConfig[col.type];

    if (!config) {
        return;
    }

    const payload: GLAccountLookupRequest = {
        userGpid: this.globalVariable.getUserGPID,
        systemId: Number(this.globalVariable.getSelectedSystemId),
        lookupFieldName: config.lookupFieldName,
        lookupFieldValue: event.query,
    };

    if (config.requiresCompanyCode) {
        payload.companyCode = this.mappedCompanyCode?.trim();
    }

    this.commonService.getGLAutoComboValueLookup <any> (payload).subscribe({
        next: (response) => {
          if (col.type === 'tradingPartnerAutoComplete') {
            this.filteredTradingPartners = response;
          }
        },
        error: (err) => {
          this.commonService.showMessage(`Error loading ${col.title} values: ${err.error?.message || 'Unknown error'}`, 'error');
        },
    });
  }

  getActivityTypeValues() {
    const payload: GLAccountLookupRequest = {
      userGpid: this.globalVariable.getUserGPID,
      systemId: Number(this.globalVariable.getSelectedSystemId),
      lookupFieldName: "glactivitytype",
      lookupFieldValue: "",
    };

    this.commonService.getGLAutoComboValueLookup(payload).subscribe({
      next: (response: any[]) => {
        this.activityTypeOptions = response;
        this.glAccountOptions = this.activityTypeOptions
            .filter(item => item.glAccount)
            .map(item => ({
                glAccount: item.glAccount
            }));
      },
      error: (err) => {
        this.commonService.showMessage('Error loading GL Account values: ' + err.error.message, 'error');
      }
    });
  }

  getCustNonPOFRGLAccountValues() {
    const payload: GLAccountLookupRequest = {
      userGpid: this.globalVariable.getUserGPID,
      systemId: Number(this.globalVariable.getSelectedSystemId),
      lookupFieldName: "FRCUSTNONPOGLACCOUNT",
      lookupFieldValue: "",
      doctypeId: this.documentTypeId?.toString()
    };

    this.commonService.getGLAutoComboValueLookup(payload).subscribe({
      next: (response: any[]) => {
        this.frGlAccountCostCenterMappings = response;
        this.glAccountOptions = response
            .filter(item => item.glAccount)
            .map(item => ({
                glAccount: item.glAccount
            }));
      },
      error: (err) => {
        this.commonService.showMessage('Error loading GL Account values: ' + err.error.message, 'error');
      }
    });
  }

  onActivityTypeChange(rowData: any, field: string) {
    const selectedActivity = this.activityTypeOptions.find(opt => opt.activityType === rowData[field]);
    if (!selectedActivity) return;
    
    rowData['activityType'] = selectedActivity.activityType;
    rowData['profitCenter'] = this.isCustWorkFlowBaName === 'BA' ? selectedActivity.profitCenterBA : selectedActivity.profitCenterRS;
    rowData['glAccount'] = selectedActivity.glAccount;
    rowData['isGlAccountEditable'] = this.isCustGLEntryTableDisplay && selectedActivity.activityType === 'Other';
  }

  onCustGLAccountChange(rowData: any, field: string, rowIndex: number) {
    if(this.isCustGLEntryTableDisplay && !this.isCustNWEGLEntry){
      const selectedGLAccount = this.activityTypeOptions.find(opt => opt.glAccount === rowData[field]);
      if (!selectedGLAccount) return;
      rowData['profitCenter'] = this.isCustWorkFlowBaName === 'BA' ? selectedGLAccount.profitCenterBA : selectedGLAccount.profitCenterRS;
    } else {
      const selectedGLAccount = this.frGlAccountCostCenterMappings.find(opt => opt.glAccount === rowData[field]);
      if (!selectedGLAccount) return;
      rowData['costCenter'] = selectedGLAccount.costCenter;

      this.selectedCostCenters[rowIndex] = {
        value: selectedGLAccount.costCenter,
      };
    }
  }
  

  onGlAccountSelect(event: AutoCompleteSelectEvent, rowData: any, rowIndex: number) {
    const selected = event.value as GLAccountLookupResponseDto;
    this.selectedGLAccounts[rowIndex] = event; 
    rowData['glAccount'] = selected.glCode.trim();
    rowData['glAcName'] = selected.name.trim();
  }

  onGlAccountInputChange(value: string, rowIndex: number) {
    if (!value || !this.selectedGLAccounts[rowIndex] || this.selectedGLAccounts[rowIndex].costCenter !== value) {
      this.selectedGLAccounts[rowIndex] = null;
    }
  }

  searchCostCenters(event: any, field: string) {
    if (!event || typeof event.query !== 'string') {
      return;
    }

    const value = event.query;
    const payload: GLAccountLookupRequest = {
      userGpid: this.globalVariable.getUserGPID,
      systemId: Number(this.globalVariable.getSelectedSystemId),
      lookupFieldName: "COSTCENTER",
      lookupFieldValue: value,
      companyCode: this.mappedCompanyCode?.trim() ||  this.companyCodeMappings[0].companyCode
    };

    this.commonService.getGLAutoComboValueLookup<CostCenterLookupResponseDto>(payload).subscribe({
      next: (response: CostCenterLookupResponseDto[]) => {
        this.filteredCostCenters = response;
      },
      error: (err) => {
        this.commonService.showMessage('Error loading GL Account values: ' + err.error.message, 'error');
      }
    });
  }

  onCostCenterSelect(event: AutoCompleteSelectEvent, rowData: any, rowIndex: number) {
    const selected = event.value as CostCenterLookupResponseDto;
    this.selectedCostCenters[rowIndex] = event; 
    rowData['costCenter'] = selected.costCenter.trim();
    rowData['costCenterName'] = selected.name.trim();
  }

  onCostCenterInputChange(value: string, rowIndex: number) {
    if (!value || !this.selectedCostCenters[rowIndex] || this.selectedCostCenters[rowIndex].costCenter !== value) {
      this.selectedCostCenters[rowIndex] = null;
    }
  }

  getCompanyCodeMappings() {
    const payload: GLAccountLookupRequest = {
      userGpid: this.globalVariable.getUserGPID,
      systemId: Number(this.globalVariable.getSelectedSystemId),
      lookupFieldName: "companycodemappings",
      lookupFieldValue: this.documentTypeId!.toString(),
    };

    this.commonService.getGLAutoComboValueLookup(payload).subscribe({
      next: (response: any[]) => {
        this.companyCodeMappings = response;
      },
      error: (err) => {
        this.commonService.showMessage('Error loading Companycode mappings: ' + err.error.message, 'error');
      }
    });
  }

  public get isSaveEnabled(): boolean {
    return this.isAnyRowBeingEdited;
  }

  public triggerSaveRow(): void {
    if (!this.isAnyRowBeingEdited) return;

    const editedIndices = Object.keys(this.editingGLEntryTableRows).map(Number);

    if (editedIndices.length === 0) return;

    const indexToSave = editedIndices[0];
    this.saveRow(indexToSave);
  }

  validateAmountCommon(value: string, fieldRef: any) {
    if (!value) {
      fieldRef.control.setErrors(fieldRef.control.errors?.['required'] ? { required: true } : null);
      return;
    }

    //Only allow digits, commas, and dots
    const validPattern = /^[\d,\.]+$/;
    if (!validPattern.test(value)) {
      fieldRef.control.setErrors({ pattern: true });
      return;
    }

    //Replace last comma with dot (if any) for decimal
    let sanitized = value;
    const lastComma = sanitized.lastIndexOf(',');
    if (lastComma >= 0) {
      sanitized = sanitized.substring(0, lastComma) + '.' + sanitized.substring(lastComma + 1);
    }

    //Remove other commas/dots for numeric parsing
    const numericString = sanitized.replace(/[^\d\.]/g, '');
    const numericValue = parseFloat(numericString);

    if (isNaN(numericValue)) {
      fieldRef.control.setErrors({ pattern: true });
      return;
    }

    //Minimum value > 0
    if (numericValue <= 0) {
      fieldRef.control.setErrors({ min: true });
      return;
    }

    //Clear errors if valid
    fieldRef.control.setErrors(null);
  }

  isAutoCompleteField(type: string): boolean {
    return [
      'tradingPartnerAutoComplete',
    ].includes(type);
  }

  getAutoCompleteSuggestions(field: string): any[] {
    if (field === 'tradingPartner') {
      return this.filteredTradingPartners;
    }
    return [];
  }

  getAutoCompleteDisplayField(col: any): string {
    if (col.type === 'tradingPartnerAutoComplete') {
      return 'tradingPartnerId';
    }
    return col.field;
  }

  getAutoCompleteDisplayValue(item: any, col: any): string {
    const field = this.getAutoCompleteDisplayField(col);
    return item?.[field]?.toString().trim() || '';
  }

  onAutoCompleteSelect(event: AutoCompleteSelectEvent, rowData: GlEntryView, rowIndex: number, col: { type: string; field: string }): void {
    const selected = event.value;

    if (col.type === 'tradingPartnerAutoComplete') {
      this.selectedTradingPartner[rowIndex] = event;
      rowData.tradingPartner = selected.tradingPartnerId?.trim();
    }
  }

  onAutoCompleteInputChange(value: string, rowIndex: number, col: { type: string; field: string }): void {
    const config: Record<string, {
      selectedArray: any[];
      selectedValueField: string;
    }> = {
      tradingPartnerAutoComplete: {
        selectedArray: this.selectedTradingPartner,
        selectedValueField: 'tradingPartnerId'
      }
    };

    const fieldConfig = config[col.type];

    if (!fieldConfig) {
      return;
    }

    const selectedEvent = fieldConfig.selectedArray[rowIndex];

    if (!value || !selectedEvent || selectedEvent.value?.[fieldConfig.selectedValueField]?.trim() !== value.trim()) {
      fieldConfig.selectedArray[rowIndex] = null;
    }
  }

  isValidAutoCompleteSelection(value: any, rowIndex: number, col: any): boolean {
    if (col.type === 'tradingPartnerAutoComplete') {
      return !!this.selectedTradingPartner[rowIndex];
    }
    return true;
  }
}
